import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStickyNote } from "@fortawesome/free-solid-svg-icons";

interface AssetStyle {
  icon: string | undefined;
  class: string;
}

const iconMap: Record<string, any> = {
  faStickyNote: faStickyNote,
};

interface AssetIconProps {
  assetStyle: AssetStyle;
}

const AssetIcon = ({ assetStyle }: AssetIconProps) => {
  return (
    <>
      {assetStyle.icon ? (
        <FontAwesomeIcon icon={iconMap[assetStyle.icon]} />
      ) : (
        <i className={`icon-${assetStyle.class}${assetStyle.class === "node" ? "-tool" : ""}`} />
      )}
    </>
  );
};

export default AssetIcon;
